class inquireForm extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#inquireDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setProductImagesButtonAccessibility();
  }

  setProductImagesButtonAccessibility() {
    const moreImagesButton = document.querySelector('#inquireModal');
    if (!moreImagesButton) return;

    moreImagesButton.setAttribute('role', 'button');
    moreImagesButton.setAttribute('aria-haspopup', 'dialog');
    moreImagesButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(moreImagesButton);
    });
    moreImagesButton.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(moreImagesButton);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    let globoFormInputUrl = document.querySelector('.globo-form input[placeholder="Product Url"]');
    let globoFormInputTitle = document.querySelector('.globo-form input[placeholder="Product Title"]');
    let globoFormInputSku = document.querySelector('.globo-form input[placeholder="Product Sku"]');
    
    if (globoFormInputUrl) {
      globoFormInputUrl.setAttribute('value', this.dataset.productHandle);
      globoFormInputUrl.setAttribute('readonly', 'true');
      globoFormInputUrl.style.color = '#99989c';
      globoFormInputUrl.style.background = '#f1f1f1';
      console.log(globoFormInputUrl);
      // clearInterval(imagesInterval); // Stop the interval once iframe is found and modified
    }
    
    if (globoFormInputTitle) {
      globoFormInputTitle.setAttribute('value', this.dataset.productTitle);
      globoFormInputTitle.setAttribute('readonly', 'true');
      globoFormInputTitle.style.color = '#99989c';
      globoFormInputTitle.style.background = '#f1f1f1';
      console.log(globoFormInputTitle);
      // clearInterval(imagesInterval); // Stop the interval once iframe is found and modified
    }
    
    if (globoFormInputSku) {
      globoFormInputSku.setAttribute('value', this.dataset.productSku);
      globoFormInputSku.setAttribute('readonly', 'true');
      globoFormInputSku.style.color = '#99989c';
      globoFormInputSku.style.background = '#f1f1f1';
      console.log(globoFormInputSku);
      // clearInterval(imagesInterval); // Stop the interval once iframe is found and modified
    }

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('inquireDrawer');
        const focusElement = this.querySelector('.product-images__inner') || this.querySelector('.product-images__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.documentElement.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.documentElement.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('inquire-form', inquireForm);
